import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePropertiesManyMutationVariables = Types.Exact<{
  updates: Array<Types.Properties_Updates> | Types.Properties_Updates;
}>;


export type UpdatePropertiesManyMutation = { __typename?: 'mutation_root', update_properties_many?: Array<{ __typename?: 'properties_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, photo_link?: string | null, premium?: boolean | null, tier_status?: string | null, warranty_expiration_date?: any | null, warranty_start_date?: any | null, created_at?: any | null, updated_at?: any | null, organization_id: any, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null }> } | null> | null };


export const UpdatePropertiesManyDocument = gql`
    mutation updatePropertiesMany($updates: [properties_updates!]!) {
  update_properties_many(updates: $updates) {
    affected_rows
    returning {
      id
      name
      address
      address_id
      standardized_address {
        id
        street_1
        street_2
        city
        state
        postal_code
        country
      }
      photo_link
      premium
      tier_status
      warranty_expiration_date
      warranty_start_date
      created_at
      updated_at
      organization_id
    }
  }
}
    `;
export type UpdatePropertiesManyMutationFn = Apollo.MutationFunction<UpdatePropertiesManyMutation, UpdatePropertiesManyMutationVariables>;

/**
 * __useUpdatePropertiesManyMutation__
 *
 * To run a mutation, you first call `useUpdatePropertiesManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertiesManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertiesManyMutation, { data, loading, error }] = useUpdatePropertiesManyMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdatePropertiesManyMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePropertiesManyMutation, UpdatePropertiesManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePropertiesManyMutation, UpdatePropertiesManyMutationVariables>(UpdatePropertiesManyDocument, options);
      }
export type UpdatePropertiesManyMutationHookResult = ReturnType<typeof useUpdatePropertiesManyMutation>;
export type UpdatePropertiesManyMutationResult = Apollo.MutationResult<UpdatePropertiesManyMutation>;
export type UpdatePropertiesManyMutationOptions = Apollo.BaseMutationOptions<UpdatePropertiesManyMutation, UpdatePropertiesManyMutationVariables>;